import FleetAdminAction from 'components/FleetAdminAction';
import useFleetAdminPermissions from 'utils/User/useFleetAdminPermissions';
import useModalVisibility from 'hooks/useModalVisibility';
import AddAssetModal from '../Account/Depots/AddAssetModal';
import AddAssetMenu from '../Account/Depots/AddAssetModal/AddAssetMenu';
import BulkAddAssetModal from '../Fleets/BulkAddAssetModal';
import BulkAddAssetProvider, {
  useBulkAddAssetContext,
} from '../Fleets/BulkAddAssetModal/context/BulkAddAssetContext';

function AddAssetControls() {
  const { visible, openModal, closeModal } = useModalVisibility();
  const { isModalOpen: bulkModalOpen, openModal: openBulkModal } =
    useBulkAddAssetContext();
  const fleetAdminPermissions = useFleetAdminPermissions();
  const manageAssetsCapability =
    fleetAdminPermissions.anyAccount('canManageAssets');

  return (
    <>
      <FleetAdminAction capability={manageAssetsCapability}>
        {({ disabled }) => (
          <AddAssetMenu
            disabled={disabled}
            onSelectManual={openModal}
            onSelectBulk={openBulkModal}
          />
        )}
      </FleetAdminAction>
      {visible && <AddAssetModal onCancel={closeModal} />}
      {bulkModalOpen && <BulkAddAssetModal />}
    </>
  );
}

export default function AddAssetButton() {
  return (
    <BulkAddAssetProvider>
      <AddAssetControls />
    </BulkAddAssetProvider>
  );
}
